import 'jquery';
import 'metismenu';
import 'bootstrap';

import 'core-js';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { StripeProvider } from 'react-stripe-elements';
import flexibility from 'flexibility';

import { init, process, refresh } from 'css-calc-polyfill';

import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/material.css';
import 'react-circular-progressbar/dist/styles.css';
import 'react-contexify/dist/ReactContexify.min.css';

import routes from './routes';
import { store, history } from './store';

import './components/icons';

import '../public/vendor/pace/pace';
import '../public/vendor/extension';
import './../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import './../node_modules/react-bootstrap-daterangepicker/css/daterangepicker.css';
import './../node_modules/animate.css/animate.min.css';
import './../node_modules/react-select/dist/react-select.css';
import './../node_modules/react-redux-toastr/src/styles/index.scss';
import './../node_modules/react-input-range/lib/css/index.css';
import './../node_modules/font-awesome/css/font-awesome.css';
import './../public/styles/style.scss';

flexibility(document.body);

const refreshCalc = () => {
  setTimeout(() => {
    refresh();
    refreshCalc();
  }, 1000);
};

document.addEventListener('DOMContentLoaded', () => {
  init({
    contentPrefix: 'viewport-units-buggyfill;',
  });
  process();
  refreshCalc();
});

ReactDOM.render(
  <StripeProvider apiKey={STRIPE_KEY}>
    <Provider store={store}>
      <Router history={history}>{routes}</Router>
    </Provider>
  </StripeProvider>,
  document.getElementById('root'),
);
